/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { atom } from "jotai";

import { BaseService } from "@/frameworks/libraries/restservice";

class Friend extends BaseService {
	constructor() {
		super();
	}

	private APIPath = (path?: string) => `/api/friends${path ? `/${path}` : ""}`;

	private static Cache = {
		Remove: atom<WebServices.Friend.Delete.Response>({}),
		Friends: atom<WebServices.Friend.Friends.Response>({}),
		Add: atom<WebServices.Friend.AddFriend.Response>({}),
		New: atom<WebServices.Friend.ExistsNewFriend.Response>({})
	};

	public remove = (name: string, events: API.Events) => ({
		name,
		events,
		callback: ({ userId }: WebServices.Friend.Delete.Request) => this.delete(this.APIPath(userId)),
		cache: Friend.Cache.Remove
	});

	public friends = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Friend.Friends.Request) => this.get(this.APIPath(), parameter),
		cache: Friend.Cache.Friends
	});

	public add = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Friend.AddFriend.Request) => this.post(this.APIPath(), parameter),
		cache: Friend.Cache.Add
	});

	public new = (name: string, events: API.Events) => ({
		name,
		events,
		callback: (parameter: WebServices.Friend.ExistsNewFriend.Request) => this.get(this.APIPath("new"), parameter),
		cache: Friend.Cache.New
	});
}

class FriendServiceStatic {
	constructor(public readonly friend = new Friend()) {}
}
const FriendService = new FriendServiceStatic();
export default FriendService;
